import { IconButton, Tooltip } from '@mui/material'
import React, { ChangeEvent, Dispatch, FC, SetStateAction, useState } from 'react'
import { CreasAbrangencia } from 'types/creas.type'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import DialogAlert from 'components/Dialog/Alert'
import { GridColDef } from '@mui/x-data-grid'
import { DataGridCustom } from './style'

type TableDataProps = {
  handleDelete: (id: string) => void
  data: CreasAbrangencia[]

  page: number
  rowsPerPage: number
  rowsOptions: number[]

  handleRowsPerPage: (e: ChangeEvent<HTMLInputElement>) => void
  handleNewPage: (e: any, page: number) => void

  totalOfElements: number

  selectedRows: number[]
  setSelectedRows: Dispatch<SetStateAction<number[]>>
}

const TableData: React.FC<TableDataProps> = ({
  data,
  handleDelete,
  rowsPerPage,
  totalOfElements,
  handleRowsPerPage,
  page,
  rowsOptions,
  handleNewPage,
  setSelectedRows,
  selectedRows,
}) => {
  const columns: GridColDef[] = [
    {
      field: 'cidade',
      headerName: 'Munícipio abrangido',
      flex: 1,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) => params.value,
      valueGetter: (params) => params.value,
    },
    {
      field: 'bairro',
      headerName: 'Bairro abrangido',
      flex: 1,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) => params.value,
      valueGetter: (params) => params.value,
    },
    {
      field: 'bairroId',
      headerName: 'Ações',
      maxWidth: 100,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      valueGetter: (params) => params.value,
      renderCell: (params) => {
        return <AbrangenciaItem item={params.row} handleDelete={handleDelete} />
      },
    },
  ]

  return (
    <>
      <DataGridCustom
        rows={data}
        columns={columns}
        autoHeight
        checkboxSelection
        localeText={{
          footerRowSelected: (numero) =>
            numero > 1 ? `${numero} selecionados` : `${numero} selecionado.`,
        }}
        onRowSelectionModelChange={(newSelection: any) => {
          setSelectedRows(newSelection)
        }}
        getRowId={(row) => row.bairroId}
        rowSelectionModel={selectedRows}
        pageSizeOptions={rowsOptions}
        rowCount={totalOfElements}
        componentsProps={{
          pagination: {
            labelRowsPerPage: 'Linhas por página:',
            labelDisplayedRows: ({ from, to, count }) =>
              `Linhas ${from}-${to} de um total de ${count} itens.`,
            onRowsPerPageChange: handleRowsPerPage,
          },
        }}
        onPaginationModelChange={({ page }) => {
          handleNewPage(null, page)
        }}
        paginationModel={{
          page: page,
          pageSize: rowsPerPage,
        }}
      />
    </>
  )
}

type AbrangenciaItem = {
  handleDelete: (id: string) => void
  item: CreasAbrangencia
}

const AbrangenciaItem: FC<AbrangenciaItem> = ({ item, handleDelete }) => {
  const [openExcluded, setOpenExcluded] = useState<boolean>(false)

  const handleDeleteDialog = () => {
    handleDelete(item.bairroId)
  }

  return (
    <>
      <Tooltip title='Remover'>
        <IconButton color='error' aria-label='print' onClick={() => setOpenExcluded(true)}>
          <DeleteOutlineRoundedIcon color='error' />
        </IconButton>
      </Tooltip>
      <DialogAlert
        title='Excluir'
        contentText={`Tem certeza que deseja excluir a área de abrangência?`}
        open={openExcluded}
        onSuccess={handleDeleteDialog}
        onClose={() => setOpenExcluded(false)}
      />
    </>
  )
}

export default TableData
